import { getSurveyAnswers } from "@/lib/utils/survey-storage";
import { RESIDENTIAL_PROPERTY_TYPES, COMMERCIAL_PROPERTY_TYPE } from "@/components/survey/_constants/surveyQuestions";

// Maps the homepage/get-in-touch survey's propertyType answer (raw labels
// like "Apartment"/"Villa"/"Office / Commercial Space") onto this page's
// Residential/Commercial filter chip — the two taxonomies differ, so this is
// not a passthrough. Backs the Property type filter's "pre-applied from
// survey" behavior per the find-contractors filter PRD.
export function getSurveyPropertyTypeFilter() {
  const { propertyType } = getSurveyAnswers();
  if (propertyType === COMMERCIAL_PROPERTY_TYPE) return "Commercial";
  if (RESIDENTIAL_PROPERTY_TYPES.includes(propertyType)) return "Residential";
  return null;
}
